<div [ngClass]="separateDialCodeClass">
    <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
        <input
            style="padding: 0"
            type="tel"
            nz-input
            mask="(000) 000-0000"
            [nzBorderless]="borderless"
            autocomplete="tel-national"
            (blur)="onTouched()"
            [(ngModel)]="phoneNumber"
            (ngModelChange)="onPhoneNumberChange()"
            [disabled]="disabled"
            [placeholder]="placeholder"
            #focusable
        />
    </nz-input-group>
    <ng-template #addOnBeforeTemplate>
        <nz-select
            style="min-width: 80px"
            nzShowSearch
            nzAllowClear
            autocomplete="tel-country-code"
            nzPlaceHolder="select country"
            class="phone-input-country-select"
            [compareWith]="compareFn"
            [nzFilterOption]="filterFn"
            [(ngModel)]="selectedCountry"
            (ngModelChange)="onCountrySelect(focusable)"
        >
            <nz-option
                *ngFor="let country of preferredCountriesInDropDown"
                class="iti__country iti__standard"
                nzCustomContent
                [nzLabel]="'+' + country.dialCode"
                [nzValue]="country"
                [id]="country.htmlId + '-preferred'"
            >
                <span class="iti__country-name">{{ country.name }} </span>
                <span class="iti__dial-code"> +{{ country.dialCode }}</span>
            </nz-option>

            <nz-option-group nzLabel="All countries">
                <nz-option
                    *ngFor="let country of allCountries"
                    class="iti__country iti__standard"
                    nzCustomContent
                    [nzLabel]="'+' + country.dialCode"
                    [nzValue]="country"
                    [id]="country.htmlId"
                >
                    <span class="iti__country-name">{{ country.name }} </span>
                    <span class="iti__dial-code"> +{{ country.dialCode }}</span>
                </nz-option>
            </nz-option-group>
        </nz-select>
    </ng-template>
</div>
